import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateVariableCategoryValue } from 'store/data/variables';

type HandlerInput = Parameters<typeof updateVariableCategoryValue>[0];

export function useUpdateVariableCategoryValue(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.UPDATE_VARIABLE_CATEGORY_VALUE
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(updateVariableCategoryValue(input));
	}

	return [{ loading, error }, handler];
}
